export type ReferralRole = 'invitee' | 'referrer';

export type InviteChannel = 'copy_link' | 'share_link' | 'email_invite';

export type ReferralLocation =
  | 'invites_tab'
  | 'invites_account'
  | 'invites_header'
  | 'referral_share_card'
  | 'share_banner'
  | 'feedback_success_modal'
  | 'inquiry_success_grow_community'
  | 'quick_action';

export const REFERRAL_COPY = {
  invitee: {
    shareLinkMessage:
      "I use Primum to curbside expert oncologists and get answers in under 24 hours. It's free for NPI-verified providers. Earn or donate $100 to your charity of choice when you ask your first question within 30 days. You can even ask anonymously, and there are paid survey opportunities too.",
    inviteEmailIncentiveLine:
      'Sign up with the link below and earn or donate $100 to your charity of choice when you ask your first question within 30 days.',
    createAccountBannerCopy:
      'Sign up and earn or donate $100 to your charity of choice when you ask your first question within 30 days.',
  },
  referrer: {
    invitesHeroSubtitle:
      "Invite your colleagues and you'll both earn or donate $100 to your charity of choice when they ask their first question within 30 days.",
    feedbackSuccessCopy:
      "Know a colleague who would benefit from Primum? Invite them, and you'll both earn or donate $100 to your charity of choice when they ask their first question within 30 days.",
    inquirySuccessGrowCommunityDescription:
      "Your inquiry has been submitted! Primum was created to support oncologists at all stages of their journey. Refer a colleague and you'll each earn or donate $100 to your charity of choice when they ask their first inquiry.",
    authCardDefaultCopy:
      "Refer a colleague and you'll both earn or donate $100 to your charity of choice when they ask their first question.",
    shareCardCopy:
      "Refer a colleague and you'll both earn or donate $100 to your charity of choice when they ask their first question within 30 days.",
  },
} as const;

export const INVITE_COPY_VERSION = '2026-02-24_charity' as const;
